<template>
  <div
    id="app"
    class="chat-101agent"
    :style="{
      position: cssposition.position,
      top: cssposition.top,
      right: cssposition.right,
      bottom: cssposition.bottom,
      left: cssposition.left,
      zIndex: cssposition.zindex,
    }"
  >
    <transition
      enter-active-class="animate__animated animate__zoomIn"
      leave-active-class="animate__animated animate__zoomOut"
      mode="out-in"
    >
      <ChatComponent
        v-if="showChat"
        @minimize="minimize"
        @activate-voice-mode="_activateVoiceMode"
        @deactivate-voice-mode="_deactivateVoiceMode"
        @on-upload-file="_uploadFile"
        @on-msg-send="_msgSend"
        :active="chatActive"
        :messages="chatMessages"
        :user="currentUser"
        :agent_name="agentname"
        :agent_photo_url="agent_photo_url"
        :lang="agentlang"
        :colors="colors"
        :mode="mode"
        :no_budget="params.no_budget"
        :logo101url="logo101url"
      />
      <MiniChat
        v-else-if="mode != 'qr' && mode != 'sound'"
        @openChat="openChat"
        @activate-voice-mode="_activateVoiceMode"
        @deactivate-voice-mode="_deactivateVoiceMode"
        :active="chatActive"
        :mini_msg="minimsg"
        :agent_photo_url="agent_photo_url"
        :lang="agentlang"
        :colors="colors"
      />
    </transition>
  </div>
</template>

<script>
import {
  onMounted,
  ref,
  watch,
  reactive,
  inject,
  onBeforeMount,
  nextTick,
} from "vue";
import ChatComponent from "./components/ChatComponent.vue";
import MiniChat from "./components/MiniChat.vue";
import { eventBus } from "@/eventBus";
import { chatMessagesData1 } from "./components/data";
export default {
  components: { ChatComponent, MiniChat },
  setup() {
    const showChat = ref(false);
    const assetUrl = process.env.VUE_APP_ASSET_URL;
    const mode = ref(null);
    const forcechat = ref(false);
    const params = inject("params");
    const colors = ref({});
    const cssposition = ref({});
    const chatActive = ref(null);
    const chatMessages = ref(chatMessagesData1);
    const currentUser = ref("");
    const currentAgent = ref("Clara");
    const minimsg = ref(null);
    const agentname = ref("");
    const agent_photo_url = ref("");
    const logo101url = ref(`${assetUrl}/img/101agent.png`);
    const agentlang = reactive({
      is_listening: "is listening...",
      has_stop_listening: "has stopped listening.",
      open_chat: "Open Chat",
      deactivate: "Deactivate",
      activate: "Activate",
      quit: "Quit",
      enter_message: "Type a message...",
      today: "Today",
      me: "Me",
      click_to_call: "Click to contact agent.",
      press_to_talk: "Click here to talk to an agent.",
      press_to_talk_again: "Click to talk to %s again.",
      service_unavailable: "Service unavailable",
    });
    async function loadLanguage(langCode) {
      try {
        const res = await fetch(`${assetUrl}/lang/${langCode}.json`);
        const data = await res.json();
        Object.assign(agentlang, data);
      } catch (err) {
        console.error("Error loading language:", err);
      }
    }
    const _emitHangupOutsideShadow = (com_id) => {
      console.log("hangup101agent event");
      const event = new CustomEvent("hangup101agent", {
        detail: { com_id: com_id },
        bubbles: true,
        composed: true, // <-- this is required to escape Shadow DOM
      });
      // Emit on the root element
      document.dispatchEvent(event); // or use $el.dispatchEvent if inside `mounted`
    };
    onBeforeMount(() => {
      mode.value = params.mode;
    });
    onMounted(() => {
      forcechat.value = params.forcechat;
      eventBus.on("logourlupdated", (url) => {
        if (url != null) logo101url.value = url;
      });
      if (params.no_budget == true) {
        minimsg.value = agentlang.service_unavailable;
      }
      if (localStorage.getItem("agent101activevoicemode") === null)
        chatActive.value = params.autolaunch;
      if (
        localStorage.getItem("agent101activevoicemode") === "true" ||
        localStorage.getItem("agent101activevoicemode") === "false"
      )
        if (mode.value == "qr") {
          chatActive.value = false;
        } else {
          chatActive.value = JSON.parse(
            localStorage.getItem("agent101activevoicemode")
          );
        }
      eventBus.on("setColors", (newcolors) => {
        colors.value = newcolors;
      });
      eventBus.on("setPosition", (newposition) => {
        cssposition.value = newposition;
      });
      eventBus.on("setUser", (username) => {
        currentUser.value = username;
      });
      eventBus.on("setLang", (lang) => {
        loadLanguage(lang);
      });
      eventBus.on("initAgent", (data) => {
        currentAgent.value = data.agentname;
        agentname.value = data.agentname;
        agent_photo_url.value = data.agentphoto;
      });
      eventBus.on("fetchCallUrl", () => {
        _emitHangupOutsideShadow(localStorage.getItem("com_id"));
        chatMessages.value.push({
          id: null,
          name: "waiting audio..",
          type: "waitaudio",
        });
      });
      eventBus.on("websocketMessageReceived", (data) => {
        chatMessages.value.push({
          id: data.id,
          align: data.role == "assistant" ? "left" : "right",
          name: data.role == "assistant" ? currentAgent : currentUser,
          message: data.transcript,
          type: "text",
          time: data.date,
        });
        if (data.role == "assistant") {
          minimsg.value = data.transcript;
        }
      });
      eventBus.on("websocketHangup", () => {
        _deactivateVoiceMode();
      });

      eventBus.on("callDone", (call_url, datetime) => {
        // Find and remove waitaudio messages in-place to keep reactivity
        for (let i = chatMessages.value.length - 1; i >= 0; i--) {
          if (chatMessages.value[i].type === "waitaudio") {
            chatMessages.value.splice(i, 1);
          }
        }
        chatMessages.value.push({
          id: null,
          align: "right",
          url: call_url,
          type: "audio",
          time: datetime,
        });
      });
    });

    const openChat = () => {
      showChat.value = true;
    };
    const minimize = () => {
      showChat.value = false;
    };
    watch(
      () => forcechat.value,
      async (newval) => {
        if (newval == true) {
          openChat();
          await nextTick();
          eventBus.emit("forcevisiblechat");
        }
      }
    );

    watch(
      () => mode.value,
      (newval) => {
        if (newval == "qr") {
          openChat();
        }
      }
    );

    watch(
      () => agentlang,
      (newVal) => {
        if (currentUser.value == null || currentUser.value == "") {
          currentUser.value = newVal.me;
        }
        if (chatMessages.value[0].name == "Today") {
          chatMessages.value[0].name = newVal.today;
        }
      },
      { deep: true }
    );
    watch(
      () => chatActive.value,
      (current_val, previous_val) => {
        if (current_val) {
          eventBus.emit("startVoiceCall");
        } else {
          if (previous_val != null) {
            eventBus.emit("endVoiceCall");
          } else {
            if (params.no_budget) {
              minimsg.value = agentlang.service_unavailable;
            } else {
              minimsg.value = agentlang.click_to_call;
            }
          }
        }
        localStorage.setItem(
          "agent101activevoicemode",
          JSON.stringify(current_val)
        );
      }
    );
    const _activateVoiceMode = () => {
      console.log("trying");
      chatActive.value = true;
    };
    const _deactivateVoiceMode = () => {
      chatActive.value = false;
    };

    const _msgSend = (message) => {
      eventBus.emit("sendTextMessage", message);
    };
    const getCurrentDateTime = () => {
      const now = new Date();

      // Format day, month, year, hours, and minutes
      const day = String(now.getDate()).padStart(2, "0");
      const month = String(now.getMonth() + 1).padStart(2, "0"); // Months are 0-based
      const year = now.getFullYear();
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");

      return `${day}/${month}/${year} ${hours}:${minutes}`;
    };
    const _uploadFile = (object) => {
      if (
        ["image/jpeg", "image/png", "image/gif", "image/webp"].includes(
          object.file.type
        )
      ) {
        chatMessages.value.push({
          id: null,
          align: "right",
          name: currentUser,
          url: object.data,
          filename: object.file.name,
          type: "image",
          time: getCurrentDateTime(),
        });
      } else {
        chatMessages.value.push({
          id: null,
          align: "right",
          name: currentUser,
          filename: object.file.name,
          type: "file",
          time: getCurrentDateTime(),
        });
      }
      eventBus.emit("sendFile", object);
    };
    return {
      mode,
      showChat,
      openChat,
      minimize,
      chatActive,
      _activateVoiceMode,
      _deactivateVoiceMode,
      _uploadFile,
      _msgSend,
      chatMessages,
      currentUser,
      minimsg,
      agentname,
      agent_photo_url,
      agentlang,
      colors,
      cssposition,
      params,
      logo101url,
    };
  },
};
</script>
<style>
#app {
  font-family: "Poppins", Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
